import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ProductDefault } from '../../../entities/@products/ProductDefault/ProductDefault';
import { ProductVariant } from '../../../entities/@products/ProductVariant/ProductVariant';
import { Link } from '../../../entities/Link/Link';
import { AsyncReduxState, initialAsyncReduxState } from '../../defaults';

export type ProductState = AsyncReduxState<{
    isLoadingProductDefault: boolean;
    isLoadingProductVariant: boolean;
    productDefault?: ProductDefault;
    productVariant?: ProductVariant;
    breadcrumbs: Link[];
}>;

const initialState: ProductState = {
    ...initialAsyncReduxState,
    isLoadingProductDefault: false,
    isLoadingProductVariant: false,
    productDefault: undefined,
    productVariant: undefined,
    breadcrumbs: [],
};

const productSlice = createSlice({
    name: 'productSlice',
    initialState,
    reducers: {
        setIsLoadingProductDefault(state, action: PayloadAction<boolean>): ProductState {
            return {
                ...state,
                isLoadingProductDefault: action.payload,
            };
        },
        setIsLoadingProductVariant(state, action: PayloadAction<boolean>): ProductState {
            return {
                ...state,
                isLoadingProductVariant: action.payload,
            };
        },
        setHasFetched(state, action: PayloadAction<boolean>): ProductState {
            return {
                ...state,
                hasFetched: action.payload,
            };
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): ProductState {
            return {
                ...state,
                isSuccessful: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): ProductState {
            return {
                ...state,
                error: action.payload,
            };
        },
        setBreadcrumbs(state, action: PayloadAction<Link[]>): ProductState {
            return {
                ...state,
                breadcrumbs: action.payload,
            };
        },
        setProductDefault(state, action: PayloadAction<ProductDefault | undefined>): ProductState {
            return {
                ...state,
                productDefault: action.payload,
            };
        },
        setProductVariant(state, action: PayloadAction<ProductVariant | undefined>): ProductState {
            return {
                ...state,
                productVariant: action.payload,
            };
        },
    },
});

export const {
    setIsLoadingProductDefault,
    setIsLoadingProductVariant,
    setIsSuccessful,
    setError,
    setHasFetched,
    setBreadcrumbs,
    setProductDefault,
    setProductVariant,
} = productSlice.actions;

export default productSlice;
